import Player from '@vimeo/player';

let isPlaying = false;

const playVideo = (event, el, player, type) => {
    event.preventDefault();
    el.classList.add('playing');

    // Delay for animation
    setTimeout(() => {
        if (type === 'vimeo') {
            player.play();
        } else {
            player.playVideo();
        }

        isPlaying = true;
    }, 300);
};

const stopVideo = (event, el, player, type) => {
    event.preventDefault();
    el.classList.remove('playing');

    // Delay for animation
    setTimeout(() => {
        if (type === 'vimeo') {
            player.unload();
        } else {
            player.stopVideo();
        }

        isPlaying = false;
    }, 300);
};

const initVideoEmbeds = (elements) => {
    elements.forEach((el) => {
        let player;

        const video = el.querySelector('.js-video-iframe');
        const openBtns = el.querySelectorAll('.js-play-video');

        if (el.dataset.videoEmbed === 'youtube') {
            let YT;

            const playerReady = () => {
                openBtns.forEach((btn) => {
                    btn.addEventListener('click', (event) => {
                        if (isPlaying) {
                            stopVideo(event, el, player, 'youtube');
                        } else {
                            playVideo(event, el, player, 'youtube');
                        }
                    });
                });
            };

            window.onYouTubePlayerAPIReady = () => {
                YT = window.YT;

                player = new YT.Player(video, {
                    events: {
                        onReady: playerReady
                    }
                });
            };

            // Inject YouTube API script if it doesn't exist
            const ytScript = document.getElementById('youtubeAPI');

            if (!ytScript) {
                const scriptEl = document.createElement('script');
                scriptEl.src = 'https://www.youtube.com/player_api';
                scriptEl.id = 'youtubeAPI';

                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(scriptEl, firstScriptTag);
            }
        } else {
            player = new Player(video);

            openBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    if (isPlaying) {
                        stopVideo(event, el, player, 'vimeo');
                    } else {
                        playVideo(event, el, player, 'vimeo');
                    }
                });
            });
        }
    });
};

export default initVideoEmbeds;
